<script setup lang="ts">
import AutocompleteField from '@/components/Selector/AutocompleteField.vue'
import type { CheckpointModel } from '@/types/models/CheckpointModel'

type Props = {
    inputValue?: string
    checkpointId?: number
    checkpointOptions: CheckpointModel[]
    isLoadingCheckpoints?: boolean
    disabled?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'typing', value?: string): void
    (e: 'select', value: CheckpointModel | undefined, event: PointerEvent): void
}
defineEmits<Emits>()
</script>

<template>
    <AutocompleteField
        :label="$t('device.filters.checkpoint')"
        :modelValue="inputValue ?? checkpointOptions.find(item => item.id === checkpointId)?.name"
        :loading="isLoadingCheckpoints"
        @typing="$emit('typing', $event)"
        @select="(value, event) => $emit('select', value as CheckpointModel, event)"
        :options="checkpointOptions"
        :disabled="disabled" />
</template>
